// import librerias
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LoginScreen } from "../pages/Account/LoginScreen";
import { Aviso } from "../pages/legal/Aviso";
import { DashboardRoutes } from "./DashboardRoutes";
import { PrivateRoute } from "./PrivateRoute";
import { PublicRoute } from "./PublicRoute";
import { LegalRoute } from "./LegalRoute";

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <LoginScreen />
            </PublicRoute>
          }
        />
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <DashboardRoutes />
            </PrivateRoute>
          }
        />
    {/* <Route
      path="/aviso-de-privacidad"
      element={
        <LegalRoute>
          <Aviso />
        </LegalRoute>
      }
    /> */}
      </Routes>
    </BrowserRouter>
  );
};
